import { useEffect } from "react";

const TawkToWidget = () => {
  useEffect(() => {
    if (document.getElementById("tawk-script")) return;

    const script = document.createElement("script");
    script.id = "tawk-script";
    script.src = "https://embed.tawk.to/68945411fcd547192ddda872/1j21mgpmd";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    return () => {
      const existing = document.getElementById("tawk-script");
      if (existing) existing.remove();
    };
  }, []);

  return null;
};

export default TawkToWidget;